import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isPrerender } from '~/utils/is-prerender';

// Legally-required (EU Directive 2023/2673) "withdrawal from contract" entry point.
// Pinned bottom-left so it is visible without scrolling, offset right of the cookie-settings
// widget, and hidden while the footer is on screen so it never overlaps footer content
// (e.g. the Greek ESPA banner).
const WithdrawalStickyButton = () => {
	const { t } = useTranslation();
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		let observer;
		let cancelled = false;

		// The footer is lazy-loaded, so wait for it to mount before observing.
		const attach = () => {
			if (cancelled) return;
			const footer = document.querySelector('footer');
			if (!footer) {
				setTimeout(attach, 500);
				return;
			}
			observer = new IntersectionObserver(entries => setHidden(entries.some(entry => entry.isIntersecting)));
			observer.observe(footer);
		};
		attach();

		return () => {
			cancelled = true;
			if (observer) observer.disconnect();
		};
	}, []);

	if (isPrerender()) return null;

	const label = t('withdrawal_sticky_button');

	return (
		<Link
			to="/return-order?mode=withdrawal"
			className={`withdrawal-sticky-button${hidden ? ' is-hidden' : ''}`}
			aria-label={label}
			aria-hidden={hidden}
			tabIndex={hidden ? -1 : undefined}>
			<svg className="withdrawal-sticky-button__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="square"
					strokeLinejoin="miter"
					d="M6 3h8l4 4v14H6V3zM14 3v4h4M9 12h6M9 16h6"
				/>
			</svg>
			<span className="withdrawal-sticky-button__label">{label}</span>
		</Link>
	);
};

export default WithdrawalStickyButton;
